
import { Component, Vue } from 'vue-property-decorator'
import { MinioRessource } from '../../lib/models/MinioRessource'

import PictureChooser from './PictureChooser.vue'

@Component({
  components: {
    PictureChooser
  }
})
export default class RallyRoundVoucherChooser extends Vue {
  pictures: MinioRessource[] = []

  mounted () {
    this.loadPictures()
    this.$store.dispatch('loadRallyRound', this.$route.params.rallyRoundId)
  }

  async loadPictures () {
    this.pictures = await MinioRessource.getAllForContext('voucher-pictures')
  }

  async pictureSaved () {
    this.$store.dispatch('forceReloadRallyRound', this.$route.params.rallyRoundId)
    await this.loadPictures()
  }

  async saveSelectedPicture (id: number) {
    this.$store.state.PageURLRallyRound.rallyRound.voucherId = id
    await this.$store.state.PageURLRallyRound.rallyRound.update()
    this.$store.dispatch('forceReloadRallyRound', this.$route.params.rallyRoundId)
  }
}
